module.exports = __webpack_public_path__ + "img/1.867f084c.jpeg";